var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3631_16909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.51495C4.32065 1.51495 1.33398 4.50162 1.33398 8.18162C1.33398 11.8616 4.32065 14.8483 8.00065 14.8483C11.6807 14.8483 14.6673 11.8616 14.6673 8.18162C14.6673 4.50162 11.6807 1.51495 8.00065 1.51495ZM8.00065 11.515C7.63398 11.515 7.33398 11.215 7.33398 10.8483V8.18162C7.33398 7.81495 7.63398 7.51495 8.00065 7.51495C8.36732 7.51495 8.66732 7.81495 8.66732 8.18162V10.8483C8.66732 11.215 8.36732 11.515 8.00065 11.515ZM8.66732 6.18162H7.33398V4.84829H8.66732V6.18162Z",
    fill: "#55555A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3631_16909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.181641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/Tooltip.9037111932fd02c4959d69b485522f3c.svg";
export { ForwardRef as ReactComponent };